import React from 'react';
import PropTypes from 'prop-types';
import ValidationError from 'components/common/ValidationError';
import classnames from 'classnames';

// Exported for components that should only show
// when a user is promoting content.
export const CONTENT_PROMO = 'contentpromo';

export const CHAR_LIMIT = 100;

export const OBJECTIVES = {
  businesspromo: 'Raise awareness for a brand, business, or organization',
  [CONTENT_PROMO]: 'Promote a concert or music related content',
};

// TODO: split RadioList to be its own form-common field component
export const Objective = ({
  input: { onChange, value },
  meta: { touched, error },
}) => (
  <div className={classnames('form-group', { 'has-error': touched && error })}>
    <label>Choose your objective</label>
    <fieldset className="objective-select">
      <ul>
        {Object.keys(OBJECTIVES).map(k =>
          (<li key={k}>
            <div className="input-group">
              <span className="input-group-addon">
                <input
                  type="radio"
                  value={k}
                  id={`objective-${k}`}
                  checked={value === k}
                  onChange={onChange}
                />
              </span>
              <label htmlFor={`objective-${k}`}>
                {OBJECTIVES[k]}
              </label>
            </div>
          </li>)
        )}
      </ul>
    </fieldset>
    { touched && error && <ValidationError errorMsg={error} /> }
  </div>
);

Objective.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

export default Objective;



// WEBPACK FOOTER //
// ./src/components/BuildAd/Steps/CampaignStep/Objective.js